import React from 'react';
import './estilo.css';
import LeiaMais from '../LeiaMaisBox';

const CardInfoParques = (props) => {
  const dicionarioParques = {
    "CO": "Centro-Oeste",
    "L": "Leste",
    "N": "Norte",
    "S": "Sul"
  }

    return(
        <div className="card-info_container">
            <div className="card-info">
              { props.parque.portoes &&
                <div style={{marginBottom: "15px"}}>
                  <h3 style={{margin: "0", marginBottom: "3px", fontWeight: "500"}}>Portões:</h3>
                  <LeiaMais texto={props.parque.portoes} linhas={3}/>
                </div>
              }
              <div>
                <h3 style={{margin: "0", fontWeight: "500", display: "inline"}}>Região: </h3>
                <h4 style={{marginTop: "7px", marginLeft: "5px", fontWeight: "400", display: "inline"}}>{dicionarioParques[props.parque.regiao]}</h4>
              </div>
              <div style={{marginTop: "15px"}}>
                <h3 style={{margin: "0", fontWeight: "500", display: "inline"}}>Subprefeitura: </h3>
                <h4 style={{marginTop: "7px", marginLeft: "5px", fontWeight: "400", display: "inline"}}>{props.parque.subprefeitura}</h4>
              </div>
              <div style={{marginTop: "15px"}}>
                <h3 style={{margin: "0", fontWeight: "500", display: "inline"}}>Área Total: </h3>
                <h4 style={{marginTop: "7px", marginLeft: "5px", fontWeight: "400", display: "inline"}}>{props.parque.area} m²</h4>
              </div>
              <div style={{marginTop: "15px"}}>
                <h3 style={{margin: "0", fontWeight: "500", display: "inline"}}>Inaugurado: </h3>
                <h4 style={{marginTop: "7px", marginLeft: "5px", fontWeight: "400", display: "inline"}}>{props.parque.inaugurado}</h4>
              </div>
              { props.parque.titulo_decreto && 
                <div style={{marginTop: "15px"}}>
                  <h3 style={{margin: "0", fontWeight: "500", display: "inline"}}>Decreto: </h3>
                  {props.parque.url_decreto ?
                    <a href={props.parque.url_decreto} style={{marginTop: "7px", fontWeight: "400"}} target="_blank" rel="noopener noreferrer">{props.parque.titulo_decreto}</a>
                    :
                    <p style={{marginTop: "7px", marginLeft: "5px", fontWeight: "400", display: "inline"}}>{props.parque.titulo_decreto}</p>
                  }
                  
                </div>
              }
              { props.parque.titulo_lei && 
                <div style={{marginTop: "15px"}}>
                  <h3 style={{margin: "0", fontWeight: "500", display: "inline"}}>Lei: </h3>
                  {props.parque.url_lei ?
                    <a href={props.parque.url_lei} style={{marginTop: "7px", fontWeight: "400"}} target="_blank" rel="noopener noreferrer">{props.parque.titulo_lei}</a>
                    :
                    <p style={{marginTop: "7px", marginLeft: "5px", fontWeight: "400", display: "inline"}}>{props.parque.titulo_lei}</p>
                  }
                </div>
              }
              { props.parque.plano_gestor && 
                <div style={{marginTop: "15px"}}>
                  <h3 style={{margin: "0", fontWeight: "500", display: "inline"}}>Plano de Gestão: </h3>
                  <a href={props.parque.plano_gestor} style={{marginTop: "7px", fontWeight: "400"}} target="_blank" rel="noopener noreferrer">Plano de Gestão dos Parques da Orla da Represa Guarapiranga</a>
                </div>
              }
              { props.parque.exibir_horario_funcionamento != 0 && 
                <div style={{marginTop: "15px"}}>
                  <h3 style={{margin: "0", fontWeight: "500"}}>Horário de funcionamento: </h3>
                  <h4 style={{marginTop: "7px", fontWeight: "400", marginBottom: "0"}}>{((props.parque.horario_funcionamento || "").charAt(0) || "").toUpperCase()}{(props.parque.horario_funcionamento || "").slice(1)}</h4>
                </div>
              }
              {/* <div style={{marginTop: "15px"}}>
                <h3 style={{margin: "0", fontWeight: "500", display: "inline"}}>Capacidade máxima: </h3>
                <h4 style={{marginTop: "7px", marginLeft: "5px", fontWeight: "400", display: "inline"}}>
                  {
                    props.parque.limite === 0?
                      "Não aplica"
                    :props.parque.limite + " pessoas"
                  }
                </h4>
              </div> */}
              {
                props.parque.agendamento &&
                  <div style={{ marginTop: "15px" }}>
                    <h3 style={{ margin: "0", fontWeight: "500"}}>Agendamento: </h3>
                    <h4 style={{ marginTop: "7px", marginLeft: "12px", fontWeight: "400" }}>{props.parque.agendamento}</h4>
                  </div>
              }
              { props.parque.fone &&
                <div style={{marginTop: "15px"}}>
                  <h3 style={{margin: "0", fontWeight: "500", marginBottom: "7px", display: "inline"}}>Contato: </h3>
                  <h4 style={{marginTop: "0", fontWeight: "400", display: "inline", marginLeft: "5px"}}>(11) {props.parque.fone}</h4>
                  {props.parque.fone2 && <h4 style={{marginTop: "0", fontWeight: "400", display: "inline", marginLeft: "5px"}}> / <br /> (11) {props.parque.fone2}</h4>}
                </div>
              }
              { props.parque.como_chegar &&
                <div style={{marginTop: "15px"}}>
                  {props.parque.tipo === "Natural" ? 
                  <h3 style={{margin: "0", marginBottom: "3px", fontWeight: "500"}}>Localização:</h3>
                  : 
                  <h3 style={{margin: "0", marginBottom: "3px", fontWeight: "500"}}>Como chegar:</h3>}
                  <LeiaMais texto={props.parque.como_chegar} linhas={3}/>
                </div>
              }
              {props.parque.topicos_extras.map(info => (
                  info.local == 'card' &&
                  <div style={{marginTop: "15px"}}>
                      {info.tipo == 'link' ?
                      <h3 style={{margin: "0", marginBottom: "3px", fontWeight: "500", display: "inline"}}>{info.titulo_topico}: </h3>
                      :
                      <h3 style={{margin: "0", marginBottom: "3px", fontWeight: "500", display: "inline"}}>{info.titulo_topico}</h3>
                      }
                      {info.tipo == 'link' ?
                      <a href={info.url_topico} style={{marginTop: "7px", fontWeight: "400"}} target="_blank" rel="noopener noreferrer">{info.texto_topico}</a>
                      :
                      <LeiaMais texto={info.texto_topico} linhas={3}/>
                      }
                  </div>
              ))}
          </div>
        </div>
    ); 
}

export default CardInfoParques;